module.exports = __webpack_public_path__ + "12d72a51393420558faec4d4e6fb5256.svg";